import { AlbumsSortBy } from 'common/enums';
import { Album } from 'models/album';

export function filterAlbumsBySearch(albums: Album[], query: string): Album[] {
  if (!query.trim()) return albums;
  const q = query.toLowerCase().trim();
  return albums.filter((album) => album.name?.toLowerCase().includes(q));
}

export function sortAlbums(
  list: Album[],
  sortBy: AlbumsSortBy | null,
): Album[] {
  if (!sortBy) return list;

  const sorted = [...list];
  switch (sortBy) {
    case AlbumsSortBy.recentActivity:
      return sorted.sort(
        (a, b) =>
          new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
      );
    case AlbumsSortBy.oldestActivity:
      return sorted.sort(
        (a, b) =>
          new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime(),
      );
    case AlbumsSortBy.recentlyAdded:
      return sorted.sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      );
    case AlbumsSortBy.earliestAdded:
      return sorted.sort(
        (a, b) =>
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
      );
    case AlbumsSortBy.aToZ:
      return sorted.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }),
      );
    case AlbumsSortBy.zToA:
      return sorted.sort((a, b) =>
        b.name.localeCompare(a.name, undefined, { sensitivity: 'base' }),
      );
    // The planner's order: the API sends albums in it (globalOrderIndex).
    case AlbumsSortBy.custom:
      return sorted.sort(
        (a, b) => (a.globalOrderIndex ?? 0) - (b.globalOrderIndex ?? 0),
      );
    default:
      return sorted;
  }
}
